import "../../forms/customCheckbox.scss"; // Import the styling for your checkbox component
import PropTypes from "prop-types";

const VideoCheckbox = ({ id, label, checked, onChange }) => {
  return (
    <div className="custom-checkbox">
      <input
        type="checkbox"
        id={id}
        onChange={onChange}
        checked={checked}
        className="checkbox-input"
        aria-checked={checked} // Accessibility attribute
      />
      <label htmlFor={id} className="checkbox-label">
        <span className="checkmark"></span>
        {label}
      </label>
    </div>
  );
};

VideoCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default VideoCheckbox;
